import { render, staticRenderFns } from "./BrandColorInput.vue?vue&type=template&id=6214f940"
import script from "./BrandColorInput.vue?vue&type=script&lang=js"
export * from "./BrandColorInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports